
export const styles = theme => ({
    root: {
        display: 'flex',
        marginTop: '1.5rem',
        paddingTop: '1.5rem',
        paddingLeft: '1.5rem',
    },

    formControl: {
        '@media screen and (min-width: 400px)': {
        marginBottom: '22.31%'
        },
    },

    formLabel: {
        marginBottom: '10.97%',
        textTransform: 'capitalize',
        fontSize: '16px'
    },

    label: {
        height: 20,
        marginBottom: 12,
        marginRight: 0
    },

    containerExp: {
        display: 'flex',
        alignItems: 'center',
        background: '#f4f4f4',
        height: 40,
        position: 'relative',
        width: '100%',
        marginLeft: -17,

        '@media only screen and (min-width:480px) and (max-width:600px) ': {
        marginTop: '3.624%',
        display: 'flex',
        alignItems: 'center',
        background: '#f4f4f4',
        height: 30,
        position: 'relative',
        }
    },
    square: {
        width: 118,
        height: 40,
        background: 'red',
        '@media only screen and (min-width:480px) and (max-width:600px) ': {
        width: 118,
        height: 30,
        background: 'red',
        }
    },
    arrowRight: {
        '@media only screen and (min-width:600.98px) ': {
        width: 0,
        height: 0,
        borderTop: '20px solid transparent',
        borderBottom: '20px solid transparent',
        borderLeft: '20px solid red',
        },
        '@media only screen and (min-width:480px) and (max-width:600px) ': {
        borderTop: '15px solid transparent',
        borderBottom: '15px solid transparent',
        borderLeft: '15px solid red',
        }
    },

    titleLeft: {
        '@media screen and (min-width: 1440px)': {
        position: 'absolute',
        top: '50%',
        left: '6%',
        transform: 'translate(-50%,-50%)',
        color: '#ffffff',
        },
        '@media screen and (min-width: 1280px) and (max-width: 1439.98px)': {
        position: 'absolute',
        top: '50%',
        left: '8%',
        transform: 'translate(-50%,-50%)',
        color: '#ffffff',
        },
        '@media only screen and (min-width:1024.98px) and (max-width:1280px) and (orientation:landscape)': {
        position: 'absolute',
        top: '50%',
        left: '6%',
        transform: 'translate(-50%,-50%)',
        color: '#ffffff',
        },
        '@media only screen and (min-width:480px) and (max-width:1024px) ': {
        position: 'absolute',
        top: '50%',
        left: '10%',
        transform: 'translate(-50%,-50%)',
        color: '#ffffff',
        }
    },
    titleRight: {
        '@media screen and (min-width: 1200px)': {
        marginLeft: 12
        },
        '@media only screen and (min-width:768.98px) and (max-width:1024px)': {
        fontSize: '0.875rem',
        marginLeft: 17,
        },
        '@media only screen and (min-width:480px) and (max-width:768px)': {
        fontSize: '0.75rem',
        marginLeft: 17,
        }
    },
    nameModule: {
        textTransform: 'capitalize'
    },
    link: {
        textDecoration: 'underline',
        cursor: 'pointer'
    },
       paperWidthSm: {
        width: '80%',
        maxWidth: 'unset',
    },
    // title: {
    //     '@media screen and (min-width: 1200px) and (max-width: 1920px)': {
    //         fontSize: 34,
    //         fontWeight: 500,
    //     },
    // },
    marginCloseButton: {
        marginTop: 4,
        minWidth: 45
    },
    rootDialogContent: {
        padding: '0% 3.8542%',
    },
    rootDialogActions: {
        margin: 0,
        position: 'absolute',
        top: '0%',
        right: '0%'
    },
    title: { 
        padding: 0,
        fontSize: '1.5rem',
        textAlign: 'center', 
        fontWeight: '500',
        lineHeight: 'normal',
    },
    DialogTitle: {
        padding: '1.5rem' 
    },
    DialogContent: {
      padding: '0 0.5rem', 
    },
})